import { MultiSelect, Select } from "@mantine/core";
import React, { useEffect, useState } from "react";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { withTranslation } from "react-i18next";
import Page from "../../../components/Page";
import { backendUrl } from "../../../constants";
import "./styles.css";

const Index = ({ skillsData, setSkillsData }) => {
  const [skills, setSkills] = useState([]);
  const [interests, setInterests] = useState([]);
  const [langs, setLangs] = useState([]);
  const [privacyLevels, setPrivacyLevels] = useState([]);

  //Skills
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}skill/listSkill`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.skillName };
          setSkills((skill) => [...skill, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //interests
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}interest/listInterest`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.interestName };
          setInterests((interest) => [...interest, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //langauges
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookUp/getLookupByType/languages`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setLangs((p) => [...p, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //privacy Levels
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/privacyLevel`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setPrivacyLevels((p) => [...p, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <Page
      style={{ backgroundColor: "rgb(248, 248, 248)", padding: "20px 0px" }}
    >
      <div className="skills-main">
        <h2 className="text-dark text-center py-2">Skills & More</h2>
        <p className="text-center">
          Studies show that by adding all 15 skill sets to your profile you get
          <b> 200-300 more job offerings.</b>
        </p>
        <div className="row d-flex justify-content-between align-items-end">
          <MultiSelect
            label="Your Skills"
            placeholder="Select..."
            data={skills}
            value={skillsData.skills}
            className="col-md-9"
            maxDropdownHeight={400}
            onChange={(v) => setSkillsData((data) => ({ ...data, skills: v }))}
          />
          <Select
            placeholder="Privacy Level"
            data={privacyLevels}
            className="col-md-3"
            disabled={!skillsData.skills}
            value={skillsData?.skillPrivacyLevel}
            onChange={(v) =>
              setSkillsData((data) => ({
                ...data,
                skillPrivacyLevel: v,
              }))
            }
          />
        </div>
        <div className="row d-flex justify-content-between align-items-end">
          <MultiSelect
            label="Your Langauges"
            placeholder="Select..."
            className="col-md-9"
            value={skillsData?.jobSeekerLanguages}
            data={langs}
            maxDropdownHeight={400}
            onChange={(v) =>
              setSkillsData((data) => ({
                ...data,
                jobSeekerLanguages: v,
              }))
            }
          />
          <Select
            placeholder="Privacy Level"
            disabled={!skillsData.jobSeekerInterets}
            data={privacyLevels}
            className="col-md-3"
            value={skillsData.interestPrivacyLevel}
            onChange={(v) =>
              setSkillsData((data) => ({
                ...data,
                interestPrivacyLevel: v,
              }))
            }
          />
        </div>
        <div className="row d-flex justify-content-between align-items-end">
          <MultiSelect
            label="Your Interests"
            placeholder="Select..."
            className="col-md-9"
            data={interests}
            maxDropdownHeight={400}
            value={skillsData?.jobSeekerInterets}
            onChange={(v) =>
              setSkillsData((data) => ({
                ...data,
                jobSeekerInterets: v,
              }))
            }
          />
          <Select
            placeholder="Privacy Level"
            disabled={!skillsData.jobSeekerLanguages}
            data={privacyLevels}
            value={skillsData?.languagePrivacyLevel}
            className="col-md-3"
            onChange={(v) =>
              setSkillsData((data) => ({
                ...data,
                languagePrivacyLevel: v,
              }))
            }
          />
        </div>
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
